<template>
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <router-link to="/" class="brand-link">
      <img
        src="@/assets/adminlte/img/AdminLTELogo.png"
        alt="AdminLTE Logo"
        class="brand-image img-circle elevation-3"
        style="opacity: .8"
      />
      <span class="brand-text font-weight-light">Connecta</span>
    </router-link>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column nav-compact nav-child-indent" data-widget="treeview" role="menu" data-accordion="false">
          <li class="nav-header">MENU</li>
          <li class="nav-item">
            <router-link to="/dashboard" class="nav-link">
              <i class="nav-icon fas fa-tachometer-alt"></i>
              <p>
                Dashboard
              </p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/user" class="nav-link">
              <i class="nav-icon fas fa-angel"></i>
              <p>
                Usuários Anjo
              </p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/protective_measure" class="nav-link">
              <i class="nav-icon fas fa-user-shield"></i>
              <p>
                Medidas Protetivas
              </p>
            </router-link>
          </li>
          <li class="nav-header" v-if="$store.state.authUser.isAdmin">ADMINISTRAÇÃO</li>
          <li class="nav-item" v-if="$store.state.authUser.isAdmin">
            <router-link to="/usuario" class="nav-link">
              <i class="nav-icon fas fa-users"></i>
              <p>
                Usuários
              </p>
            </router-link>
          </li>
          <li class="nav-item" v-if="$store.state.authUser.isAdmin">
            <router-link to="/usuario_grupo" class="nav-link">
              <i class="nav-icon fas fa-user-unlock"></i>
              <p>
                Perfil de Usuários
              </p>
            </router-link>
          </li>
          <li class="nav-item" v-if="$store.state.authUser.isAdmin">
            <router-link to="/configuracao" class="nav-link">
              <i class="nav-icon fas fa-tools"></i>
              <p>
                Configurações
              </p>
            </router-link>
          </li>
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
export default {
  name: "SidebarMenu",
  data: function() {
    return {

    };
  },
  computed: {

  },
  methods: {

  }
};
</script>

<style>
</style>